module.exports = __webpack_public_path__ + "static/media/logo.426b3a47.png";